import { hc } from "hono/client";
import type { AppType } from "@torah-auctions/api";

export type ApiClient = ReturnType<typeof hc<AppType>>;

// Build a typed RPC client. Pass a custom `fetch` from the caller (e.g. a
// Tauri-aware fetch on desktop, or a fetch that injects auth cookies on web).
//
//   const api = createApiClient("https://api.torahauctions.com");
//   const orgs = await api.api.orgs.mine.$get().then((r) => r.json());
//
// The route names mirror the Hono path with slashes replaced by property
// access, and the trailing $get / $post / $patch / $delete picks the method.
export type ApiClientOptions = {
  fetch?: typeof globalThis.fetch;
  headers?: Record<string, string>;
};

export function createApiClient(
  baseUrl: string,
  options: ApiClientOptions = {},
): ApiClient {
  const f = options.fetch ?? globalThis.fetch;
  return hc<AppType>(baseUrl, {
    fetch: f.bind(globalThis),
    headers: options.headers,
    init: { credentials: "include" }, // forward Better Auth cookies
  });
}

// Re-export shared types so consumers don't need to also depend on the API
// package directly.
export type { AppType };
